import * as React from 'react';

import {RouteComponentProps} from 'react-router';
import Lesson from '../modules/lessons/domain/aggregates/lesson/Lesson';
import EntityId from '../../foundation/domain/EntityId';
import Page from './Page';
import { Form, Input, Button, Dropdown, Table, Grid, Breadcrumb, Header, Icon, Card } from 'semantic-ui-react';

import 'brace/mode/xml';
import 'brace/theme/monokai';
import ExerciseApi from '../modules/lessons/api/ExerciseApi';
import Exercise from '../modules/lessons/domain/aggregates/exercise/Exercise';
import LessonApi from '../modules/lessons/api/LessonApi';
import ExerciseComponent from './components/exercises/ExerciseComponent';
import ExerciseTemplateApi from '../modules/lessons/api/ExerciseTemplateApi';
import Registry from '../global/Registry';
import BBMLParser from './components/exercises/BBMLParser';
import ExerciseTemplate from '../modules/lessons/domain/aggregates/exerciseTemplate/ExerciseTemplate';
import CourseApi from '../modules/lessons/api/CourseApi';
import {Link} from 'react-router-dom';

interface Props {
	lessonId: string;
	id?: string;
	templateId?: string;
}

interface State {
	exercise?: Exercise;
	lessons: Lesson[];
	lesson?: Lesson;
	preview: boolean;
	exercises: Exercise[];
}

export default class ExercisePage extends Page<RouteComponentProps<Props>, State> {

	public constructor (props: RouteComponentProps<Props>) {
		super(props);

		this.state = { lessons: [], preview: false, exercises: [] };
	}

	async componentWillMount () {
		await this.initialize(this.props);
	}

	async componentWillReceiveProps (props: RouteComponentProps<Props>) {
		await this.initialize(props);
	}

	async initialize (props: Readonly<RouteComponentProps<Props>>) {
		await CourseApi.getInstance().getAll();
		const lessons = await LessonApi.getInstance().getAll();
		await ExerciseTemplateApi.getInstance().getAll();
		const exerciseIdValue = this.props.match.params.id;
		const exercise = await ExerciseApi.getInstance().getById(new EntityId<Exercise>(Number(exerciseIdValue)));
		const lesson = Registry.getInstance().lessonRepository.getById(exercise.getLessonId());
		const exercises = await ExerciseApi.getInstance().getAllByCourseId(lesson.getCourseId());

		this.setState({exercise, lessons, lesson, exercises});
	}

	protected isLoading () {
		return this.props.match.params.id !== undefined && this.state.exercise === undefined || this.state.lesson === undefined;
	}

	protected renderTitle () {
		return '';
	}

	protected renderDescription () {
		return '';
	}

	protected renderContent () {
		const exercise = this.state.exercise as Exercise;

		const me = Registry.getInstance().me;

		const lesson = this.state.lesson as Lesson;
		const course = Registry.getInstance().courseRepository.getById(lesson.getCourseId());

		const sections = [{ key: 'Home', content: <Link to='/'>Home</Link> }, { key: 'Course', content: <Link to={course.getSlug()}>{course.getName()}</Link> }, { key: 'Lesson', content: <Link to={lesson.getSlug() + '/exercises'}>{lesson.getTitle()}</Link>}, { key: 'Exercise', content: exercise.getFirstAnswer(), active: true}];

		const exerciseTemplate = exercise.getTemplateId().isNull() ? null : Registry.getInstance().exerciseTemplateRepository.getById(exercise.getTemplateId());
		const templateName = exerciseTemplate === null ? '' : exerciseTemplate.getName();

		const parentExercises = this.state.exercises.filter(parentExercise => parentExercise.getUsedExerciseIds().map(id => id.getValue()).includes(exercise.getId().getValue()));

		return (
			<div className='lesson'>
				<Breadcrumb icon='right angle' sections={sections} />
				<Header inverted as={'h1'} dividing>{exercise.getFirstAnswer()}</Header>

				{this.renderCard(exercise)}

				{exercise.getUsedExerciseIds().length === 0 ? null : (
					<div>
						<Header inverted as={'h2'} dividing style={{marginTop: '32px'}}>Vocabulary breakdown</Header>
						{exercise.getUsedExerciseIds().map(id => this.state.exercises.find(exercise => exercise.getId().equals(id))).map(exercise => this.renderCard(exercise))}
					</div>
				)}

				{parentExercises.length === 0 ? null : (
					<div>
						<Header inverted as={'h2'} dividing style={{marginTop: '32px'}}>Example usages</Header>
						{parentExercises.map(exercise => this.renderCard(exercise))}
					</div>
				)}
			</div>
		);
	}

	private renderCard (exercise?: Exercise) {
		if (exercise === undefined) {
			return null;
		}

		const hasExplanation = exercise.getExplanation() !== '' && (typeof exercise.getExplanation() !== 'object' || exercise.getExplanation().props && exercise.getExplanation().props.children !== '');

		return (
			<Card key={String(exercise.getId().getValue())} href={exercise.getSlug()} fluid style={{backgroundColor: '#2D2D2D', color: 'inherit'}}>
				<Card.Content>
					<Card.Meta textAlign={'center'} style={{color: 'lightgrey'}}>{exercise.getQuestion()}</Card.Meta>
					<Card.Header textAlign={'center'} style={{color: 'white', marginTop: '16px'}}>{exercise.getFirstAnswer()}</Card.Header>
					{hasExplanation ? <Card.Description textAlign={'center'} style={{color: 'inherit', fontSize: '0.9em', borderTop: '1px solid orange', paddingTop: '8px'}}>{exercise.getExplanation()}</Card.Description> : null}
				</Card.Content>
			</Card>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/ExercisePage.tsx